/**
 * Iter-52.55.7 — Answer Key label formatter.
 *
 * Extracted so that (a) the AnswerKeyScreen doesn't pull side-effects
 * from a page module during Jest runs, and (b) both the flat answer
 * line AND the per-row picture block below it agree on the same
 * numeric+alphabetic label scheme that the exercise page uses.
 *
 * Rules (must match ExercisesPanel's Match card exactly):
 *   • Column A → "1, 2, 3, …"   (numeric, 1-indexed)
 *   • Column B → "A, B, C, …"   (alphabetic caps, up to Z = 26 items)
 *   • MCQ options → q.option_labels[i]     when printed labels exist,
 *                   else "A." … "Z."       as fallback (same as panel).
 * Never mix roman numerals with numeric fallback; never emit "[picture N]".
 */
import { isPictureItem } from './textMarkers';

export function answerTextFor(q) {
  if (!q) return '';
  if (q.type === 'match_the_following' && Array.isArray(q.answer_pairs)) {
    return q.answer_pairs
      .map((rIdx, lIdx) => {
        const leftLabel = String(lIdx + 1);
        const rightLabel = String.fromCharCode(65 + rIdx);
        const rightText = q.right?.[rIdx] || '';
        return `${leftLabel} → ${rightLabel}. ${rightText}`;
      })
      .join('\n');
  }
  if (q.type === 'mcq') {
    const useLabels = Array.isArray(q.option_labels) && q.option_labels.length === (q.options || []).length;
    const idxs = Array.isArray(q.answer_indices)
      ? q.answer_indices
      : (typeof q.answer_index === 'number' && q.answer_index >= 0 ? [q.answer_index] : []);
    if (idxs.length) {
      return idxs.map(i => {
        const label = useLabels ? q.option_labels[i] : `${String.fromCharCode(65 + i)}.`;
        const opt = (q.options || [])[i] || '';
        return `${label} ${opt}`.trim();
      }).join('; ');
    }
  }
  return q.answer || '';
}

/** Returns true if a Match Column A row is a picture (see isPictureItem). */
export function isMatchRowPicture(q, lIdx) {
  return isPictureItem(q.left?.[lIdx] || '', q.left_images?.[lIdx] || '');
}
